export var SortTypes = {
    ByStudentNameDown: { id: 0, text: 'Sort by student name' },
    ByStudentNameUp: { id: 1, text: 'Sort by student name' },
    ByTimeSpentDown: { id: 2, text: 'Sort by time spent' },
    ByTimeSpentUp: { id: 3, text: 'Sort by time spent' },
    ByNumberOfTasksCompletedDown: {
        id: 4,
        text: 'Sort by number of tasks completed',
    },
    ByNumberOfTasksCompletedUp: {
        id: 5,
        text: 'Sort by number of tasks completed',
    },
    ByAccuracyDown: { id: 6, text: 'Sort by accuracy' },
    ByAccuracyUp: { id: 7, text: 'Sort by accuracy' },
    ByNumberOfTasksStruggleDown: {
        id: 8,
        text: 'Sort by number of struggle tasks',
    },
    ByNumberOfTasksStruggleUp: {
        id: 9,
        text: 'Sort by number of struggle tasks',
    },
};
export var SortDirections = {
    None: 0,
    Asc: 1,
    Desc: 2,
};
